<template>
  <div class="fund-saving-plan-wizard">
    <div class="column col-md-24 col-lg-24 col-xl-24">
      <fund-saving-plan-illustration
        :is-consumption="isConsumption"
        :is-industry="isIndustry"
        :is-infrastructure="isInfrastructure"
        :risk-value="ranges.returnRisk.value"
      />
    </div>
    <div class="column col-md-20 col-lg-18 col-xl-18 col-md-offset-2 col-lg-offset-3">
      <div class="inner">
        <div class="themes fund-saving-plan-wizard-themes">
          <div class="header">
            <h4 class="title">
              {{ translate('label-themes') }}
            </h4>
            <button
              class="videoicon fund-saving-plan-wizard-button-play"
              data-open-info-overlay-detail="video-topics"
              @mouseover="showTippThemes = !showTippThemes"
              @mouseleave="showTippThemes = !showTippThemes"
            >
              <span
                v-if="showTippThemes"
                class="tip tool-tip"
              >
                {{ translate('tooltip-themes') }}
              </span>
            </button>
          </div>
          <div class="toggles">
            <div
              class="toggle"
              :class="{'-disabled': themesNotChooseable }"
            >
              <label
                class="toggle-switch"
                for="consumption"
              >
                <input
                  id="consumption"
                  v-model="isConsumption"
                  type="checkbox"
                  :disabled="themesNotChooseable"
                  @click="toggleCheckbox"
                >
                <span class="slider round" />
              </label>
              <span class="label">
                {{ translate('chart-label-theme-citizen') }}
              </span>
            </div>
            <div
              class="toggle"
              :class="{'-disabled': themesNotChooseable }"
            >
              <label
                class="toggle-switch"
                for="industry"
              >
                <input
                  id="industry"
                  v-model="isIndustry"
                  type="checkbox"
                  :disabled="themesNotChooseable"
                  @click="toggleCheckbox"
                >
                <span class="slider round" />
              </label>
              <span class="label">
                {{ translate('chart-label-theme-industry') }}

              </span>
            </div>
            <div
              class="toggle"
              :class="{'-disabled': themesNotChooseable }"
            >
              <label
                class="toggle-switch"
                for="infrastructure"
              >
                <input
                  id="infrastructure"
                  v-model="isInfrastructure"
                  type="checkbox"
                  :disabled="themesNotChooseable"
                  @click="toggleCheckbox"
                >
                <span class="slider round" />
              </label>
              <span class="label">
                {{ translate('chart-label-theme-infrastructure') }}
              </span>
            </div>
          </div>
        </div>
        <div class="sliders fund-saving-plan-wizard-sliders">
          <div class="slider">
            <div class="header">
              <h4 class="label">
                {{ translate('label-invest') }}
              </h4>
              <span class="result">
                <span v-if="!showInput">
                  <span class="currency">
                    CHF
                  </span>
                  <span
                    @click="clickOnInput"
                  >
                    {{ ranges.investment.valueDisplay }}
                  </span>
                </span>
                <input
                  v-show="showInput"
                  ref="inputInvestment"
                  v-model="ranges.investment.value"
                  class="resultinput"
                  @focus="focusInput"
                  @blur="clickOutsideInvestmentInput"
                >
              </span>
            </div>
            <Slider
              v-model="ranges.investment.value"
              :has-no-themes="!isConsumption && !isInfrastructure && !isIndustry"
              :step="ranges.investment.step"
              :min="ranges.investment.min"
              :max="ranges.investment.max"
              :tooltips="false"
              @slide="(e) => onUpdateInvestment(e, ranges.investment.key)"
            />
            <div class="range -three-scale">
              <span class="label">100</span>
              <span class="label">5'000</span>
              <span class="label">
                <span v-if="maxInvestment">
                  >
                </span>
                10'000
              </span>
            </div>
          </div>
          <div class="slider">
            <div class="header">
              <div class="label">
                <span class="title">
                  {{ translate('label-risk') }}
                </span>
                <button
                  class="videoicon fund-saving-plan-wizard-button-play"
                  data-open-info-overlay-detail="video-yield"
                  @mouseover="showTippRisk = !showTippRisk"
                  @mouseleave="showTippRisk = !showTippRisk"
                >
                  <span
                    v-if="showTippRisk"
                    class="tip tool-tip"
                  >
                    {{ translate('tooltip-risk') }}
                  </span>
                </button>
              </div>
              <span class="result">
                {{ getLabelReturnRiskValue }}
              </span>
            </div>
            <Slider
              v-model="ranges.returnRisk.value"
              :step="ranges.returnRisk.step"
              :min="ranges.returnRisk.min"
              :max="ranges.returnRisk.max"
              :tooltips="false"
              @change="(e) => onUpdateMaxValue(e)"
            />
            <div class="range -three-scale">
              <span class="label">
                {{ translate('label-risk-1') }}
              </span>
              <span class="label">
                {{ translate('label-risk-3') }}
              </span>
              <span class="label">
                {{ translate('label-risk-5') }}
              </span>
            </div>
          </div>
          <div
            class="slider -is-theme-fund"
            :class="{'-disabled': isThemeFundsDisabled }"
          >
            <div class="header">
              <h4 class="label">
                {{ translate('label-themes-portfolio') }}
              </h4>
              <span
                v-if="isThemeFundsDisabled"
                class="result"
              >
                {{ translate('text-not-possible') }}
              </span>
              <span
                v-else
                class="result"
              >
                {{ ranges.themeFunds.valueDisplay }}%
              </span>
            </div>
            <div class="containerslider">
              <Slider
                v-model="ranges.themeFunds.value"
                class="slider"
                :style="sliderStyle"
                :step="ranges.themeFunds.step"
                :min="ranges.themeFunds.min"
                :max="ranges.themeFunds.max"
                :tooltips="false"
                :disabled="isThemeFundsDisabled"
                @slide="(e) => onUpdate(e, ranges.themeFunds.key)"
              />
            </div>
            <div class="range">
              <div class="minmax">
                <span class="label">0%</span>
                <span class="label">100%</span>
              </div>
              <div class="valuegrid">
                <div class="grid">
                  <span class="label">20%</span>
                </div>
                <div class="grid">
                  <span class="label">40%</span>
                </div>
                <div class="grid">
                  <span class="label">60%</span>
                </div>
                <div class="grid">
                  <span class="label">80%</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <fund-saving-plan-chart
          v-if="!noPlanPossible"
          :has-no-themes="noThemesChosen"
          :labels-and-values="labelsAndValues"
          :title="translate('chart-title')"
        />
        <div
          v-if="noPlanPossible"
          class="info"
        >
          <p class="title">
            {{ translate('title-no-plan-possible') }}
          </p>
          <p class="lead">
            {{ translate('text-no-plan-possible') }}
          </p>
          <div class="action">
            <button
              data-open-info-overlay-detail="contact"
              class="button-primary-arrow"
              @click="openForm"
            >
              {{ translate('button-text-no-plan-possible') }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="full-bleed-container">
      <div class="row col-md-20 col-lg-18 col-xl-18 col-md-offset-2 col-lg-offset-3">
        <div
          v-if="!noPlanPossible"
          class="ctabanner"
        >
          <span class="text">
            {{ translate('cta-text') }}
          </span>
          <div class="cta">
            <button
              data-open-info-overlay-detail="contact"
              class="button button-primary-arrow"
              @click="openForm"
            >
              {{ translate('cta-button-text') }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="column col-md-17 col-lg-15 col-md-offset-2 col-lg-offset-3">
      <span class="legalnote">
        {{ translate('disclaimer') }}
      </span>
    </div>
  </div>
</template>

<script>
import Slider from '@vueform/slider/dist/slider.vue2';
import FundSavingPlanIllustration from '@/js/components/FundSavingPlanIllustration.vue';
import FundSavingPlanChart from './FundSavingPlanChart.vue';

export default {
  name: 'FundSavingPlanWizard',
  components: {
    FundSavingPlanIllustration,
    Slider,
    FundSavingPlanChart,
  },
  props: {
    translations: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      isConsumption: false,
      isIndustry: false,
      isInfrastructure: false,
      showInput: false,
      ranges: {
        investment: {
          key: 'investment',
          value: 100,
          valueDisplay: 100,
          step: 50,
          min: 100,
          max: 10000,
        },
        returnRisk: {
          key: 'returnRisk',
          value: 3,
          valueDisplay: 3,
          step: 1,
          min: 1,
          max: 5,
        },
        themeFunds: {
          key: 'themeFunds',
          value: 20,
          valueDisplay: 20,
          step: 1,
          min: 0,
          max: 25,
        },
      },
      sliderStyle: {
        width: '25%',
      },
      showTippThemes: false,
      showTippRisk: false,
    };
  },
  computed: {
    labelsAndValues() {
      return [
        [this.translate('chart-label-theme-citizen'), this.getConsumptionValue],
        [this.translate('chart-label-theme-industry'), this.getIndustryValue],
        [this.translate('chart-label-theme-infrastructure'), this.getInfrastructureValue],
        [this.translate('chart-label-strategy'), this.getStrategieFundsValue],
      ];
    },
    getLabelReturnRiskValue() {
      return this.translate(`label-risk-${this.ranges.returnRisk.value}`);
    },
    isThemeFundsDisabled() {
      return this.ranges.returnRisk.value === 1
        || (!this.isConsumption && !this.isIndustry && !this.isInfrastructure);
    },
    themesNotChooseable() {
      if (this.ranges.returnRisk.value === 1) {
        this.setAllThemesInactive();
      }

      return this.ranges.returnRisk.value === 1;
    },
    getStrategieFundsValue() {
      return 100 - this.ranges.themeFunds.valueDisplay;
    },
    getConsumptionValue() {
      if (!this.isConsumption) {
        return 0;
      }
      return this.calculateThemesValueChart();
    },
    getIndustryValue() {
      if (!this.isIndustry) {
        return 0;
      }
      return this.calculateThemesValueChart();
    },
    getInfrastructureValue() {
      if (!this.isInfrastructure) {
        return 0;
      }
      return this.calculateThemesValueChart();
    },
    noPlanPossible() {
      return this.ranges.returnRisk.value === 1;
    },
    noThemesChosen() {
      return !this.isConsumption && !this.isIndustry && !this.isInfrastructure;
    },
    maxInvestment() {
      return this.ranges.investment.value > 10000;
    },
    textInForm() {
      return `
        Themen-Mix:
        - Konsum: ${this.isConsumption}
        - Industrie: ${this.isIndustry}
        - Infrastruktur: ${this.isInfrastructure}

        Monatliches Investment: ${this.ranges.investment.value}
        Rendite/Risiko: ${this.getLabelReturnRiskValue}
        Fokus auf Themenfonds: ${this.isThemeFundsDisabled ? 'Nicht möglich' : `${this.ranges.themeFunds.value}%`}

        Anteile:
        - Konsum: ${this.getConsumptionValue}%
        - Industrie: ${this.getIndustryValue}%
        - Infrastruktur: ${this.getInfrastructureValue}%
        - Strategie-Fonds: ${this.isThemeFundsDisabled ? '100%' : `${this.getStrategieFundsValue}%`}

        Fondssparplan: ${this.noPlanPossible ? 'nicht möglich' : 'möglich'}
      `;
    },
    formElement() {
      return document.querySelector('[data-drupal-selector="edit-configuration"]');
    },
  },
  mounted() {
  },
  methods: {
    onUpdate(e, key) {
      this.ranges[key].valueDisplay = e;
    },
    clickOutsideInvestmentInput() {
      this.showInput = false;
      this.ranges.investment.valueDisplay = this.ranges.investment.value;
    },
    clickOnInput() {
      this.showInput = true;
      this.$nextTick(() => {
        this.focusInput();
      });
    },
    focusInput() {
      this.$refs.inputInvestment.focus();
    },
    onUpdateInvestment(e, key) {
      if (e === 10000) {
        this.showInput = true;
        this.$nextTick(() => {
          this.focusInput();
        });
      } else {
        this.showInput = false;
      }
      this.ranges[key].valueDisplay = e;
    },
    onUpdateMaxValue(e) {
      if (e === 1) {
        this.sliderStyle.width = '0%';
        this.ranges.themeFunds.max = 0;
        this.ranges.themeFunds.value = 0;
      }
      if (e === 2) {
        this.sliderStyle.width = '30%';
        this.ranges.themeFunds.max = 30;
        this.ranges.themeFunds.value = 20;
        this.ranges.themeFunds.valueDisplay = 20;
      }
      if (e === 3) {
        this.sliderStyle.width = '25%';
        this.ranges.themeFunds.max = 25;
        this.ranges.themeFunds.value = 20;
        this.ranges.themeFunds.valueDisplay = 20;
      }
      if (e === 4) {
        this.sliderStyle.width = '75%';
        this.ranges.themeFunds.max = 75;
        this.ranges.themeFunds.value = 40;
        this.ranges.themeFunds.valueDisplay = 40;
      }
      if (e === 5) {
        this.sliderStyle.width = '100%';
        this.ranges.themeFunds.max = 100;
        this.ranges.themeFunds.value = 80;
        this.ranges.themeFunds.valueDisplay = 80;
      }
    },
    toggleCheckbox() {
      this.checkbox = !this.checkbox;
      this.$emit('setCheckboxVal', this.checkbox);
    },
    calculateThemesDivideValueChart() {
      return [
        this.isConsumption, this.isIndustry, this.isInfrastructure,
      ].filter(Boolean).length;
    },
    calculateThemesValueChart() {
      const divider = this.calculateThemesDivideValueChart();
      return Math.round((this.ranges.themeFunds.value / divider) * 10) / 10;
    },
    setAllThemesInactive() {
      this.isConsumption = false;
      this.isIndustry = false;
      this.isInfrastructure = false;
    },
    openForm() {
      this.formElement.value = this.textInForm;
    },
    translate(localeKey, options = null) {
      let string = this.translations[localeKey];
      if (!string) {
        return '';
      }
      if (options) {
        Object.keys(options).forEach((key) => {
          string = string.replace(`{${key}}`, options[key]);
        });
      }
      return string;
    },
  },
};
</script>

<style>
:root {
  --slider-connect-bg: #00376E;
  --slider-bg: #B4BAC2;
  --slider-height: 9px;
  --slider-handle-width: 24px;
  --slider-handle-height: 24px;
  --slider-handle-ring-color: transparent;
}
</style>
<style src="@vueform/slider/themes/default.css"></style>
